import React from 'react';
import { BOX_IMAGE, CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface BoxImageProps {
  className?: string;
  target?: 'purchase' | 'checkout';
}
export function BoxImage({
  className = '',
  target = 'purchase'
}: BoxImageProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block rounded-md focus:outline-none focus-visible:ring-4 focus-visible:ring-blush ${className}`} data-id="element-28" data-mp="2rvi4319vzhg6">
      <img src={BOX_IMAGE} alt="HISTOLOGY & PATHOLOGY VISUAL ATLAS™ complete 6-in-1 visual study system box set" className="mx-auto w-full drop-shadow-2xl" data-id="element-29" data-mp="1z6ufowtucbye" />
    </a>;
}